<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>
<style lang="scss" scoped>
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_2.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 10px 10px 10px 20px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          {{ $t('近7日次品率趋势图') }}
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
        <div id="yongxinMesCipinlvChart" style="flex:1;" :style="{ height: chartHeight + 'px' }"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_energy_device_seven_trend',
  components: {},
  props: {},
  data() {
    return {
      timer: null,
      list1: [],
      chart1: null,
      option1: null,
      chartHeight: 0
    };
  },
  created() {
    //加入定时器
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },

  watch: {},
  activated() {
    this.resize();
  },

  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/quality/board/listWoReportRecordBadRate');
      this.list1 = response.data;
      this.makeChart();
    },
    makeChart() {
      let xData = this.list1.map(item => {
        return item.date;
      });
      let yData = this.list1.map(item => {
        return item.badRate;
      });

      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 30;
      if (!this.chart1) {
        setTimeout(() => {
          this.initChart1();
        }, 100);
      }
      setTimeout(() => {
        this.option1.xAxis.data = xData;
        this.option1.series[0].data = yData;
        this.chart1.setOption(this.option1);
      }, 200);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 30;
        if (!this.chart1) {
          return;
        }
        this.chart1.getDom().style.height = this.chartHeight - 20 + 'px';
        this.chart1.resize();
      }, 500);
    },
    initChart1() {
      this.option1 = {
        grid: {
          left: '20',
          right: '20',
          bottom: '20',
          top: '20',
          containLabel: true
        },
        // legend: {
        //   left: 'center',
        //   top: '0%',
        //   textStyle: {
        //     color: '#FFFFFF',
        //     fontSize: 12
        //   },
        //   itemWidth: 15,
        //   itemHeight: 10,
        //   itemGap: 25
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#909399'
          },
          valueFormatter: value => {
            return value.toFixed(1) + '%';
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: 'white'
            // formatter: month => {
            //   return month.substring(4, 6) + this.$t('yue');
            // }
          }
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              // formatter: '{value} %',
              rotate: 0,
              textStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: '', //this.$t('nenghao'),
            data: [],
            type: 'line',
            label: {
              normal: {
                show: true,
                fontSize: 22,
                position: 'top',
                formatter: params => {
                  return params.data.toFixed(2) + '%';
                },
                color: 'rgba(255, 18, 132, 1)'
              }
            },
            //symbol: 'none',
            itemStyle: {
              color: ' rgba(255, 18, 132, 1)',
              barBorderRadius: 6
            }
            // areaStyle: {
            //   color: {
            //     type: 'linear',
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [
            //       {
            //         offset: 0,
            //         color: 'rgba(239, 138, 3, 0)' // 0% 处的颜色
            //       },
            //       {
            //         offset: 0.01,
            //         color: 'rgba(239, 138, 3, 0.5)' // 100% 处的颜色
            //       },
            //       {
            //         offset: 1,
            //         color: 'rgba(239, 138, 3, 0)' // 100% 处的颜色
            //       }
            //     ],
            //     global: false // 缺省为 false
            //   }
            // }
          }
        ]
      };

      var chartDom = document.getElementById('yongxinMesCipinlvChart');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    }
  }
};
</script>
